import { Builder } from '@builder.io/react';

import LogoFarm from './index';

Builder.registerComponent(LogoFarm, {
  name: 'LogoFarm',
  inputs: [
    {
      name: 'logos',
      type: 'list',
      subFields: [
        {
          name: 'logo',
          type: 'reference',
          model: 'logos'
        }
      ]
    },
    {
      name: 'columns',
      type: 'object',
      defaultValue: { xs: 2, sm: 2, md: 5, lg: 5 },
      subFields: [
        { name: 'xs', type: 'number' },
        { name: 'sm', type: 'number' },
        { name: 'md', ype: 'number' },
        { name: 'lg', type: 'number' }
      ]
    },
    {
      name: 'bottomText',
      type: 'boolean',
      defaultValue: false
    },
    {
      showIf: "options.get('bottomText')",
      name: 'bottomText',
      type: 'object',
      defaultValue: {
        text: 'Trusted by the world’s most ambitious AI teams.',
        link: {
          href: '/customers',
          label: 'Meet our customers'
        }
      },
      subFields: [
        {
          name: 'text',
          type: 'string'
        },
        {
          name: 'link',
          type: 'object',
          subFields: [
            {
              name: 'href',
              type: 'string'
            },
            {
              name: 'label',
              type: 'string'
            }
          ]
        }
      ]
    }
  ]
});
